module.exports = __webpack_public_path__ + "img/science-card.10268492.png";